import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import * as S from './Rolling.styled';
import Observer from '../../etc/Observer/Observer';
import { useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';

export interface IRollingInfo {
  items: any[];
  onClickItem?: (idx: number) => void;
  onChangeItem?: (idx: number) => void;
}

const Rolling = (props: IRollingInfo) => {
  const [swiper, setSwiper] = useState<SwiperCore>();
  const { items } = props;

  const handleSwiper = (swiper: SwiperCore) => {
    setSwiper(swiper);
  };
  const handleClickSlide = (swiper: SwiperCore) => {
    props.onClickItem && props.onClickItem(swiper.realIndex);
  };
  const handleChangeSlide = (swiper: SwiperCore) => {
    props.onChangeItem && props.onChangeItem(swiper.realIndex);
  };
  const handleChangeView = (isView: boolean) => {
    if (swiper) {
      if (isView) {
        swiper.autoplay.run();
      } else {
        swiper.autoplay.pause();
      }
    }
  };

  return (
    <Observer handleState={handleChangeView}>
      <S.Wrap>
        <Swiper
          modules={[Autoplay, Pagination]}
          loop={items.length > 1}
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides={true}
          onClick={handleClickSlide}
          onSlideChange={handleChangeSlide}
          onSwiper={handleSwiper}
          autoplay={items.length > 1}
          pagination={{}}
        >
          {items.map((item: any, idx: number) => (
            <SwiperSlide key={idx}>
              <S.ImageWrapper>
                <img
                  key={item.bannerSeq}
                  alt={`banner${idx}`}
                  src={item.imageUrl}
                />
              </S.ImageWrapper>
            </SwiperSlide>
          ))}
        </Swiper>
      </S.Wrap>
    </Observer>
  );
};

export default Rolling;
